import Schedule from "../components/Schedule";
import SessionsManagement from "../components/Session/SessionsManagement";
import SessionCreation from "../components/Session/SessionCreation";
import Session from "../components/Session/Session";
import Event from "../components/Event/Event";
import EventsList from "../components/Event/EventsList";

export default [
  {
    path: "/schedule",
    name: "Horaire",
    component: Schedule,
    meta: { requiresAuth: true }
  },
  {
    path: "/sessions-management",
    name: "Sessions",
    component: SessionsManagement,
    meta: { requiresAuth: true }
  },
  {
    path: "/create/session",
    name: "Création de session",
    component: SessionCreation,
    meta: { requiresAuth: true }
  },
  {
    path: "/sessions/:sessionId",
    name: "Session",
    component: Session,
    meta: { requiresAuth: true }
  },
  {
    path: "/classes/:eventId",
    name: "Cours",
    component: Event,
    meta: { requiresAuth: true }
  },
  {
    path: "/classes",
    name: "Mes cours",
    component: EventsList,
    meta: { requiresAuth: true }
  }
];
